import { declareVrunComponent, declareVueComponent} from '/vodalys/vvuejs'

declareVrunComponent('question24Player.vrun.component', () => import('./Question24Player.vue'), null,
	function ($location) 
	{
        return function factory(id) {
            var instance = {
                'id': id,
            }
			
			var defaultAuthor = $location.search()['question24author'];
			
			if (defaultAuthor)
			{
				instance._author = defaultAuthor
			}
			
            return instance;
        }
	});

declareVueComponent('Question24PlayerQuestion',() => import('./Question24PlayerQuestion.vue'));
declareVueComponent('Question24PlayerTextfield',() => import('./Question24PlayerTextfield.vue'));
declareVueComponent('Question24PlayerQuestionsAndAsk',() => import('./Question24PlayerQuestionsAndAsk.vue'));
declareVueComponent('Question24PlayerAsk',() => import('./Question24PlayerAsk.vue'));
